import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { careersEndpoints } from '@/modules/careers/constants';

import { careersQueryKeys } from './queryKeys';

export const useCareersPageQuery = (slug: string) =>
  useQuery({
    queryKey: careersQueryKeys.page(slug),
    queryFn: async () => {
      const { data } = await fetchClient.GET(careersEndpoints.careersPage, {
        params: { path: { slug } },
      });
      return data;
    },
  });
